import React, {useState} from "react";
import {Modal, Button, Table, Form} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../App.css';

const CustomerSelectionModal = ({show, handleClose, customers, handleCustomerSelection}) => {
    const [searchTerm, setSearchTerm] = useState("");

    // filter customers based on search term
    const filteredCustomers = customers.filter(customer =>
        customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <Modal show={show} onHide={handleClose} className="custom-modal-size" size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Select Customer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/*search input*/}
                <Form.Group controlId="search" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search Customer..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}/>
                </Form.Group>

                <Table striped bordered hover className="table-hover">
                    <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Phone</th>
                        <th>Balance</th>
                        <th>Balance Limit</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredCustomers.map(customer => (
                        <tr key={customer.id} onClick={() => handleCustomerSelection(customer)} style={{cursor: 'pointer'}}>
                            <td>{customer.customer_name}</td>
                            <td>{customer.phone_number}</td>
                            <td>{customer.customer_balance}</td>
                            <td>{customer.customer_balance_limit}</td>
                            {/*<td><Button variant="success" onClick={() => handleCustomerSelection(customer.id)}>Select</Button> </td>*/}
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomerSelectionModal;